import { motion } from "framer-motion";
import { DollarSign, Eye, Brain } from "lucide-react";

const cards = [
  {
    icon: DollarSign,
    title: "Wasted Ad Spend",
    desc: "Over 60% of marketers can’t effectively measure which ads drive results. You're guessing, not knowing.",
    color: "text-red-500",
    bg: "bg-red-50",
  },
  {
    icon: Eye,
    title: "Invisible Brands",
    desc: "Your audience is exposed to thousands of ads every day. Most never capture real attention. Is yours one of them?",
    color: "text-amber-500",
    bg: "bg-amber-50",
  },
  {
    icon: Brain,
    title: "Gut Feeling \u2260 Data",
    desc: "Creative decisions based on opinion are outperformed by those driven by data and testing. Creative quality drives up to 70% of ad performance.",
    color: "text-orange-500",
    bg: "bg-orange-50",
  },
];

export default function ProblemSection() {
  return (
    <section className="py-24 bg-[#F8F9FC]" data-testid="problem-section">
      <div className="max-w-[1200px] mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight" style={{ fontFamily: 'Outfit, sans-serif', color: '#0F172A' }}>
            Most Ads Fail. <span className="gradient-text">Yours Don't Have To.</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {cards.map((card, i) => (
            <motion.div
              key={card.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              data-testid={`problem-card-${i}`}
              className="bg-white rounded-2xl border border-slate-200 p-8 hover:-translate-y-1 hover:shadow-xl hover:shadow-orange-500/10 transition-all duration-300"
            >
              <div className={`w-12 h-12 rounded-xl ${card.bg} flex items-center justify-center mb-5`}>
                <card.icon size={22} className={card.color} />
              </div>
              <h3 className="text-lg font-bold mb-2" style={{ fontFamily: 'Outfit, sans-serif', color: '#0F172A' }}>
                {card.title}
              </h3>
              <p className="text-sm leading-relaxed" style={{ color: '#475569' }}>
                {card.desc}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
